class popup {
  constructor(context) {
    context.querySelectorAll('[data-popup]').forEach(element => {
      
      const popupSizes = element.dataset.popup.split(',');
      const targetUrl = element.href;

      if (targetUrl) {
        element.addEventListener('click', e => {
          e.preventDefault();

          window.open(targetUrl, '', `height=${popupSizes[1]}, width=${popupSizes[0]}, toolbar=no, menubar=no, scrollbars=yes, resizable=no, location=no, directories=no, status=no`);

          return false;
        });
      }
    });
  }
};

export default popup;